<template>
  <div :class="wrapper_container ? '' : 'container'">
    <lazy-image
      :src="image_src"
      cover_img
      class="full-width-image"
      :lazy_src="image_lazy_src"
      alt="article image"/>
  </div>
</template>

<script>

import LazyImage from "../small_parts/LazyImage.vue";

export default {
  name: "FullWidthImage",
  components: {
    LazyImage,
  },
  props: {
    /**props**/
    image_src: {
      type: String,
      required: true,
      admin_type: 'image',
    },
    image_lazy_src: {
      type: String,
      default: '',
      admin_type: 'image',
    },
    wrapper_container: {
      type: Boolean,
      default: false,
      admin_type: 'checkbox',
    },
    /**props**/
  },
}
</script>
